import {createAction} from "@ngrx/store";

export const loadSpaces = createAction('[SPACES] LOAD');
export const loadSpacesSuccess = createAction('[SPACES] LOAD_SUCCESS', (data: any) => ({ spaces: data }));
export const spacesLoadState = createAction('[SPACES] LOAD_STATE');
